import type { JSX } from 'react';
import classNames from 'classnames';
import { Box } from '@mantine/core';
import type { ICardContentProps } from './types';
import classes from './Card.module.css';

function CardContent({ children, className, lineClamp }: Readonly<ICardContentProps>): JSX.Element {
  return (
    <Box
      className={classNames(classes.content, className)}
      style={
        lineClamp
          ? {
              WebkitLineClamp: lineClamp,
              display: '-webkit-box',
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }
          : undefined
      }
    >
      {children}
    </Box>
  );
}

export default CardContent;
